<template>
    <el-dialog 
        title="广告设置" 
        :visible.sync="dialogVisible"
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        width="1000px">
        <div slot="title"></div>
        <div class="formContent">
            <el-form :model="form" ref="form" label-width="140px" label-position="left" :disabled='readOnly?true:false'>
                <el-form-item label="广告设置" prop="companyId">
                    <div class="a-flex-rfsc" v-if="!readOnly">
                        <el-button type="primary" plain size='mini' @click="handleStartAll">全部启用</el-button>
                        <el-button type="danger" plain size='mini' @click="handleCloseAll">全部关闭</el-button>
                    </div>
                    <el-table :data="form.authList" class="a-mt-10">
                        <el-table-column label="广告名称" prop='name'></el-table-column>
                        <el-table-column label="广告编码" prop='adLocationId'></el-table-column>
                        <el-table-column label="广告平台">
                            <template slot-scope="{ row }">
                                {{ row.appId | initDic(appidListDic) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="{ row }">
                                <el-radio-group v-model="row.showType" >
                                    <el-radio :label="1">启用</el-radio>
                                    <el-radio :label="0">关闭</el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="广告关闭时长" prop="reStartDay">
                    <el-radio-group v-model="form.reStartDay" @change='reStartDayChange' >
                        <el-radio-button :label="7">7天</el-radio-button>
                        <el-radio-button :label="15">15天</el-radio-button>
                        <el-radio-button :label="30">30天</el-radio-button>
                        <el-radio-button :label="-1">永久</el-radio-button>
                        <el-radio-button :label="99">其他</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="广告恢复展示时间" prop="baseAmount">
                    <el-date-picker
                        value-format='yyyy-MM-dd'
                        :disabled='form.reStartDay != 99'
                        v-model="form.adReStartTime"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" v-if="!readOnly">
            <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
            <el-button type="primary"  @click="submit">确定</el-button>
        </div>
        <div slot="footer" v-else>
            <el-button class="plainBtn" @click="dialogVisible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>
  
<script>
export default {
    data () {
        return {
            id: '',
            stationId: '',
            dialogVisible: false,
            form: {},
            appidListDic: [
                {
                    label: '毛豆充（微信小程序）',
                    value: 'hichar.user.wxapp'
                },
                {
                    label: '毛豆充（支付宝小程序）',
                    value: 'hichar.user.aliapp'
                },
                {
                    label: '玖电毛豆充（云闪付小程序）',
                    value: 'hichar.user.unapp'
                },
                {
                    label: '安心e充（微信小程序）',
                    value: 'hichar.user.rest.wxapp'
                },
                {
                    label: '智慧e充（微信小程序）',
                    value: 'hichar.user.black.wxapp'
                }
            ]
        }
    },
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        handleStartAll () {
            if(this.form.authList && this.form.authList.length) {
                this.form.authList = this.form.authList.map(item=>{
                    return {
                        ...item,
                        showType: 1
                    }
                })
            }
        },
        handleCloseAll () {
            if(this.form.authList && this.form.authList.length) {
                this.form.authList = this.form.authList.map(item=>{
                    return {
                        ...item,
                        showType: 0
                    }
                })
            }
        },
        reStartDayChange () {
            if(this.form.reStartDay != -1 && this.form.reStartDay != 99) {
                this.form.adReStartTime = this.$getDay.getTodayBeforeDays(-this.form.reStartDay)
            }else {
                this.form.adReStartTime = ''
            }
        },
        getInfo () {
            this.$Axios._get({
                url: this.$Config.apiUrl.stationAdDetails,
                params: {
                    id: this.id
                },
            })
            .then(({data})=>{
                this.form = {
                    ...data,
                    adReStartTime: data.adReStartTime ? data.adReStartTime : ''
                }
                this.dialogVisible = true
            })
            .catch(err=>{

            })
        },
        submit () {
            let hasCloseAd = this.form.authList.find(res=>{
                return !res.showType
            })
            if(!this.form.reStartDay && hasCloseAd) {
                this.$message.warning('当前存在广告位设置为关闭状态，请选择恢复展示时间')
                return
            }
            if(this.form.reStartDay == 99 && !this.form.adReStartTime) {
                this.$message.warning('广告关闭天数为其他时，请选择广告恢复展示时间')
                return
            }
            this.$confirm('是否确认提交？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(_=>{
                let reqData
                reqData = {
                    "adSetValue": {
                        "adList": this.form.authList,
                        "adReStartTime": this.form.adReStartTime,
                        "reStartDay": this.form.reStartDay
                    },
                    "stationIds": [this.stationId]
                }
                this.$Axios._post({
                    url: this.$Config.apiUrl.setStationAd,
                    method: "post",
                    params: reqData,
                })
                .then(res=>{
                    if (res.result.code == 0) {
                        this.$message.success('广告设置成功')
                        this.dialogVisible = false
                        this.$emit('change')
                    } else {
                        this.$message.error(res.result.message)
                    }
                })
                .catch(err=>{

                })
            }).catch(err=>{ console.log(err); })
        }
    }
}
</script>

<style lang="scss" scoped>
// /deep/ .el-dialog__header{
//     padding: 0 !important;
// }
/deep/ .el-dialog__wrapper{
    display: flex;
    justify-content: center !important;
    align-items: center !important;
}
/deep/ .el-dialog__body{
    padding: 10px 20px !important;
}
/deep/ .el-dialog{
    // margin: auto !important;
}
.formContent{
    max-height: 70vh;
    overflow: auto;
}
</style>